import urlConstant from "../constants/urlConstants";

export const termsAndConditionSchema = {
  title: "Terms, Conditions, & Privacy Consent",
  type: "object",
  required: [
    "nonSolicitation",
    "limitationOfLiability",
    "arbitration",
    "consent",
    "billingPolicies",
    "baseCharge",
    "cancellationFees",
    "hospitalization",
    "cancellationWithAtLeastFourHours",
    "cancellationWithLessThanFourHours",
    "holidaysAndOvertime",
    "mileageReimbursement",
    "lateCharges",
    "insurance",
    "privacyConsent",
    "obligationOfResponsibleParty",
  ],
  properties: {
    nonSolicitation: {
      type: "object",
      title: "Non-Solicitation",
      required: ["nonSolicitationTerm"],
      properties: {
        nonSolicitationTerm: {
          type: "boolean",
          title: "I agree to the Non-Solicitation terms",
          description:
            "Client, Client’s representatives and agents (collectively, “Representative”), and each Responsible Party (as defined below) acknowledges, understands, and respects the relationship between Cambridge Caregivers and its employees. Client, and those acting on Client's behalf or on behalf of others, shall not directly or indirectly solicit, hire, or attempt to solicit or hire any person or entity employed by or contracted with Cambridge Caregivers, and shall not engage in any activity which is directed toward such an objective or result which would circumvent the Company's relationship with its employee. Client, Representative and each Responsible Party acknowledges that Cambridge Caregivers’ damages from the loss of its employee(s) may be difficult and expensive to establish; therefore, if Client solicits and hires, or in any manner attempts to solicit or hire, a Cambridge Caregiver's employee (or chooses to hire another firm representing the same employee) to work for Client, in any capacity, Client and each Responsible Party shall be responsible to pay to Cambridge Caregivers the amount of $20,000 per caregiver hired and, for professional caregivers (to include registered nurses, physician’s assistants, therapists, nutritionists, or other licensed professionals) $60,000 per professional caregiver hired, as liquidated damages, not as a penalty, and in addition to such other remedies that may be available to Cambridge Caregivers, including, without limitation, injunctive or other equitable relief and recovery of reasonable attorney's and/or collection fees.",
          errorMessage: {
            required: "Please accept the Non-Solicitation terms",
          },
        },
      },
    },
    limitationOfLiability: {
      type: "object",
      title: "Limitation of Liability",
      required: ["limitationOfLiabilityTerm"],
      properties: {
        limitationOfLiabilityTerm: {
          type: "boolean",
          title: "I agree to the Limitation of Liability terms",
          description:
            "Client, for itself and its Representative, each Responsible Party, and any other person or enterprise claiming hereunder, hereby acknowledges, understands, accepts, and agrees that Cambridge Caregivers shall not be liable or responsible for, and Client shall and does hereby waive, release and agree to indemnify and hold Cambridge, its liability, cost, damage, claims, suits, and/ or personal injury to Client or others arising in connection with the services provided by Cambridge Caregivers hereunder; Cambridge Caregivers hereby disclaims, and Client and each Responsible Party waives, and agrees not to rely upon (and shall not be entitled to rely upon), any express or implied warranties not set forth in this Agreement. The Client acknowledges and understands the natural consequences of aging, including but not limited to falls, wandering (elopements,) accidents or Client's refusal or non-compliance with physician's orders or the instructions, acts, or omissions of Cambridge Caregivers, including but not limited to medications, diet, physical activity, services or any other ordered therapy or treatment.",
          errorMessage: {
            required: "Please accept the Limitation of Liability terms",
          },
        },
      },
    },
    arbitration: {
      type: "object",
      title: "Arbitration & Jury Trial Waiver",
      required: ["arbitrationTerm"],
      properties: {
        arbitrationTerm: {
          type: "boolean",
          title: "I agree to the Arbitration & Jury Trial Waiver terms",
          errorMessage: {
            required: "Please accept the Arbitration & Jury Trial Waiver terms",
          },
        },
      },
    },
    consent: {
      type: "object",
      title: "Consent",
      required: ["consentTerm"],
      properties: {
        consentTerm: {
          type: "boolean",
          title: "I agree to the Consent terms",
          description:
            "Client or active MPOA or other Representative hereby give Cambridge Caregivers consent to use or disclose any protected health information to carry out Client's treatment, to obtain payment from insurance companies and for health care operations such as but not limited to quality reviews. Client or Representative further consent that protected health information may be received or released by Cambridge Caregivers by various means including but not limited to personal conversation, telephone, mail, email, or facsimile. Client or representative understands that they have the right to request a restriction of their protected health information used. However, they also understand that Cambridge Caregivers is not required to agree to this request. If Cambridge Caregivers agrees to the restriction the Company must abide by it. I, Client, or Representative have not requested a restriction of how my protected health information is used. Client or active MPOA understands that they may revoke this consent at any time by means of a request in writing, except for information already in use or disclosed.",
          errorMessage: {
            required: "Please accept the Consent terms",
          },
        },
      },
    },
    billingPolicies: {
      type: "object",
      title: "Billing Policies",
      required: ["billingPoliciesTerm"],
      properties: {
        billingPoliciesTerm: {
          type: "boolean",
          title: "I agree to the Billing Policies",
          description:
            "By agreeing to the billing policies, Client and each Responsible Party acknowledge, accept, and agree to be bound by all terms related to payments, charges, and billing procedures outlined in the following sections and in the Overtime Agreement above, and to be financially responsible for all sums due and owing to Cambridge Caregivers hereunder.",
          errorMessage: {
            required: "Please accept the Billing Policies terms",
          },
        },
      },
    },
    baseCharge: {
      type: "object",
      title: "Base Charge",
      required: ["baseChargeTerm"],
      properties: {
        baseChargeTerm: {
          type: "boolean",
          title: "I agree to the Base Charge terms",
          description:
            "The Client and Responsible Party shall be responsible to pay a per-hour rate for Cambridge’s  services provided in accordance with this Engagement Agreement, which shall be due and payable on or before 10 days of the invoice date on each invoice. Any late payments are subject to a late fee equal to 15% of the past due amount for Cambridge’s anticipated internal costs associated with late payments. The Client, and each Responsible Party, agrees to pay Cambridge via Automated Clearing House (ACH,) credit card. Cambridge will not draft the Client's checking account without prior notice and authorization unless the invoice remains outstanding for more than 14 days after the invoice date or upon the passing of the Client. In either of these events, the Client and or each Responsible Party hereby authorizes and agrees to allow Cambridge to charge the payment against the Client's and or Responsible Party's banking account. Banking information (above) shall be kept current at all times applicable to this Engagement Agreement, and Client agrees Cambridge shall be entitled to, and that Client shall provide, an update thereof upon request by Cambridge.",
          errorMessage: {
            required: " Please accept the Base Charge terms",
          },
        },
      },
    },
    overtimeAgreement: {
      type: "object",
      title: "Overtime Agreement",
      required: ["overtimeAgreementTerm"],
      properties: {
        overtimeAgreementTerm: {
          type: "boolean",
          title: "I agree to the Overtime Agreement terms",
          description:
            "I acknowledge that Cambridge Caregivers will not schedule a caregiver to work more than forty (40) hours in any workweek unless expressly requested by me. If I request such scheduling, I agree to be financially responsible for payment of all applicable overtime wages and charges in accordance with federal, state, and local laws, in addition to any other obligations arising under this Agreement.",
          errorMessage: {
            required: " Please accept the Overtime Agreement terms",
          },
        },
      },
    },
    cancellationFees: {
      type: "object",
      title: "Cancellation Fees",
      required: ["cancellationFeesTerm"],
      properties: {
        cancellationFeesTerm: {
          type: "boolean",
          title: "I agree to the Cancellation Fees terms",
          description:
            "Cambridge Caregivers understands that plans can change, and we strive to accommodate our clients accordingly. Nonetheless, if Client or Representative cancels a caregiver’s shift commitment within 24 hours of a particular shift's start time, Client will be charged for and responsible to pay the entirety of that shift. Furthermore, if caregivers or other staff members are sent home early, the Client or Responsible Party will be charged for the entire shift.",
          errorMessage: {
            required: "Please accept the Cancellation Fees terms",
          },
        },
      },
    },
    hospitalization: {
      type: "object",
      title: "Hospitalization",
      required: ["hospitalizationTerm"],
      properties: {
        hospitalizationTerm: {
          type: "boolean",
          title: "I agree to the Hospitalization terms",
          errorMessage: {
            required: "Please accept the Hospitalization terms",
          },
        },
      },
    },
    cancellationWithAtLeastFourHours: {
      type: "object",
      title: "Cancellation with at Least Four (4) Hours' Notice",
      required: ["cancellationWithAtLeastFourHoursTerm"],
      properties: {
        cancellationWithAtLeastFourHoursTerm: {
          type: "boolean",
          title:
            "I agree to the Cancellation with at Least Four (4) Hours' Notice terms",
          description:
            "If the Client or the Client's Authorized Representative elects to cancel the scheduled caregiving shift due to hospitalization and provides a minimum of four (4) hours' advance notice, the shift will be canceled at no cost to the Client. For clarity, the standard twenty-four (24)-hour cancellation notice requirement is waived in the event of hospitalization. This four (4)-hour notice period allows the Agency sufficient time to reassign the Caregiver and support continuity of the Caregiver's income.",
          errorMessage: {
            required:
              "Please accept the Cancellation with at Least Four (4) Hours' Notice terms",
          },
        },
      },
    },
    cancellationWithLessThanFourHours: {
      type: "object",
      title: "Cancellation with Less than Four (4) Hours' Notice",
      required: ["cancellationWithLessThanFourHoursTerm"],
      properties: {
        cancellationWithLessThanFourHoursTerm: {
          type: "boolean",
          title:
            "I agree to the Cancellation with Less than Four (4) Hours' Notice terms",
          description:
            "If fewer than four (4) hours' notice is provided, the Client will be billed for four (4) hours of service. In recognition of the emergent nature of hospitalizations, billing is limited to this four-hour minimum. For clarity, the standard twenty-four (24)-hour cancellation notice requirement is waived in the event of hospitalization. If the Agency successfully reassigns the Caregiver to another Client during the same period, the four (4)-hour charge will be waived.",
          errorMessage: {
            required:
              "Please accept the Cancellation with Less than Four (4) Hours' Notice terms",
          },
        },
      },
    },
    holidaysAndOvertime: {
      type: "object",
      title: "Holidays and Overtime",
      required: ["holidaysAndOvertimeTerm"],
      properties: {
        holidaysAndOvertimeTerm: {
          type: "boolean",
          title: "I agree to the Holidays and Overtime terms",
          description:
            "Client and each Responsible Party will be charged for and responsible to pay  for approved overtime for Cambridge Caregivers employees requested by or for the Client at Cambridge Caregivers’ overtime rates for those hours. Additionally, Cambridge Caregivers shall be entitled to charge, and Client and each Responsible Party shall be responsible to pay, holiday rates for hours worked on the following holidays: New Year’s Day, Memorial Day, July 4th, Labor Day, Veterans Day, Thanksgiving, and Christmas.",
          errorMessage: {
            required: "Please accept the Holidays and Overtime terms",
          },
        },
      },
    },
    mileageReimbursement: {
      type: "object",
      title: "Mileage and Purchase Reimbursement",
      required: ["mileageReimbursementTerm"],
      properties: {
        mileageReimbursementTerm: {
          type: "boolean",
          title: "I agree to the Mileage and Purchase Reimbursement terms",
          description:
            "If the caregiver or other Cambridge Caregiver's employee transports the Client in the caregiver’s or other Cambridge Caregiver employee’s vehicle, the caregiver or other Cambridge Caregiver's employee will receive mileage reimbursement, and said reimbursement shall be billed to and paid by the Client and/or Responsible Party at the then-current IRS mileage reimbursement rate. Additionally, in the event that the caregiver or other Cambridge Caregiver's employee purchases items on behalf of the Client, the Client and Responsible Party(s) shall be responsible for the cost thereof (including taxes or other charges) and shall be billed accordingly.",
          errorMessage: {
            required:
              "Please accept the Mileage and Purchase Reimbursement terms",
          },
        },
      },
    },
    lateCharges: {
      type: "object",
      title: "Late Charges",
      required: ["lateChargesTerm"],
      properties: {
        lateChargesTerm: {
          type: "boolean",
          title: "I agree to the Late Charges terms",
          description:
            "Payment of invoices is considered “past due” if payment is not received by Cambridge within 14 days from the invoice date.  In addition to the late fee discussed above, interest will accrue on all past due amounts until they are paid in full, and Client and each Responsible Party shall be obligated to pay, and Cambridge Caregivers shall be entitled to collect, interest on any past due amounts at the maximum per annum interest rate permitted by law. Engagements 28 days in arrears are subject to immediate termination of this Agreement at the sole discretion of Cambridge Caregivers and may result in the collection and legal proceedings, none of which shall be deemed an election of remedies. The Client and each Responsible Party agrees to pay all costs of collection, including reasonable legal fees, court costs, or other legal expenses incurred by Cambridge Caregivers in connection with the collection of any and all amounts due and/or any action or proceeding to enforce or interpret the terms of this Agreement.",
          errorMessage: {
            required: "Please accept the late charges terms",
          },
        },
      },
    },
    insurance: {
      type: "object",
      title: "Long Term Care Insurance",
      required: ["insuranceTerm"],
      properties: {
        insuranceTerm: {
          type: "boolean",
          title: "I agree to the Long Term Care Insurance terms",
          description:
            "Although services may be covered by long-term care insurance, the Client or Responsible party is accountable for obtaining payments from their own insurance provider. The Client or Responsible party is fully financially responsible for paying Cambridge Caregivers upon receipt of the invoice from Cambridge, regardless of when the Client or Responsible party receives reimbursement from their long-term care provider.",
          errorMessage: {
            required:
              "Please select any one option for Long Term Care Insurance terms",
          },
        },
      },
    },
    privacyConsent: {
      type: "object",
      title: "Privacy Consent",
      required: ["privacyConsentTerm"],
      properties: {
        privacyConsentTerm: {
          type: "boolean",
          title: "I agree to the Privacy Consent terms",
          errorMessage: {
            required: "Please accept the Privacy Consent terms",
          },
        },
      },
    },
    obligationOfResponsibleParty: {
      type: "object",
      title: "Obligation of Responsible Party",
      required: ["obligationOfResponsiblePartyTerm"],
      properties: {
        obligationOfResponsiblePartyTerm: {
          type: "boolean",
          title: "I agree to the Responsible Party Obligation terms",
          description:
            "As the Responsible Party, I hereby agree to be absolutely, continuously, and personally liable to Cambridge for the prompt payment, performance and collection of the Client’s obligations as may later arise or become due under this Agreement if they are not timely paid when due hereunder by or on behalf of the Client.  Responsible Party acknowledges and agrees that Cambridge shall not be required to first sue, seek judgment against, or enforce Client’s obligations as against the Client, or to take any other steps as a condition of Cambridge’s enforcement of Responsible Party’s obligations hereunder, nor shall the failure of Cambridge to do so in any manner or amount limit, reduce or eliminate Responsible Party’s obligations hereunder.",
          errorMessage: {
            required: "Please accept the Responsible Party Obligation terms",
          },
        },
      },
    },
    clientServicePlanAcknowledgement: {
      type: "object",
      title: "Client Participation in the Individual Service Plan",
      required: ["clientServicePlanAcknowledgementFields"],
      properties: {
        clientServicePlanAcknowledgementFields: {
          type: "object",
          required: [
            "date",
            "printedClientName",
            "clientSignatureAndContactInfo",
          ],
          properties: {
            description: {
              type: "string",
              title: "",
              description:
                "By my signature below, (1) I acknowledge that I willingly participated in and advised the Agency representative in creating the Individual Service Plan in the electronic database, (2) I confirm that his ISP is accurate and complete based on the information I, my spouse, family, and/or my authorized representative provided to Cambridge Caregivers, (3) I understand that I must contact the Agency if I wish to make requests of its care staff that are not included in this ISP, (4) I authorize Cambridge Caregivers to provide assessment and/or care plan information to primary care physicians, home health agencies, hospices, and/or long term care insurance providers, and (5) changes can be made to the Individual Service Plan during the annual supervisory visit, or upon a client change in condition. I approve all updates and changes made to the Individual Service Plan by Agency for the duration of services.",
            },
            clientSignatureAndContactInfo: {
              type: "object",
              title: "Signature of Client or Client Contact",
              required: ["signatureOfClient"],
              properties: {
                signatureOfClient: {
                  type: "string",
                  title: "Signature of Client or Client Contact",
                  errorMessage: {
                    required:
                      "Signature of client or client contact is required",
                  },
                },
              },
            },
            date: {
              type: "string",
              title: "Date",
              format: "date",
              errorMessage: {
                required: "Date is required",
                format: "Date is required",
              },
            },
            printedClientName: {
              type: "string",
              title: "Printed Name of Client/Client Contact",
              maxLength: 100,
              errorMessage: {
                required: "Printed name of client/Client contact is required",
                maxLength:
                  "Printed name of client/Client contact must be under 100 characters",
              },
            },
            agencyRepresentativeSign: {
              type: "string",
              image: urlConstant.SignImage.ErnieSignImageUrl,
            },
          },
        },
      },
    },
  },
};

export const termsAndConditionUiSchema = {
  nonSolicitation: {
    nonSolicitationTerm: { "ui:md": 12, "ui:field": "AgreementCheckboxField" },
  },
  limitationOfLiability: {
    limitationOfLiabilityTerm: {
      "ui:md": 12,
      "ui:field": "AgreementCheckboxField",
    },
  },
  arbitration: {
    arbitrationTerm: {
      "ui:md": 12,
      "ui:field": "AgreementCheckboxField",
      "ui:description": (
        <>
          All disputes regarding any aspect of this Engagement Agreement,
          including, without limitation, enforcement or interpretation of this
          Agreement, recovery of any amount due hereunder, or any claim for
          injury, harm or damage in any way associated with any goods or
          services provided hereunder, shall be subject to determination by
          binding arbitration under the rules of the American Arbitration
          Association and any such arbitration shall be conducted in Dallas
          County, Texas, in accordance with Texas law, except for its conflicts
          of laws principles.
          <b>
            THE PARTIES HEREBY WAIVE AND AGREE NOT TO INVOKE ANY STATUTORY,
            CONSTITUTIONAL OR COMMON LAW RIGHT TO A TRIAL BY JURY REGARDLESS OF
            WHETHER SUCH RIGHT ARISES UNDER STATE OR FEDERAL LAW.
          </b>
        </>
      ),
    },
  },
  consent: {
    consentTerm: { "ui:md": 12, "ui:field": "AgreementCheckboxField" },
  },
  billingPolicies: {
    billingPoliciesTerm: { "ui:md": 12, "ui:field": "AgreementCheckboxField" },
  },
  baseCharge: {
    baseChargeTerm: { "ui:md": 12, "ui:field": "AgreementCheckboxField" },
  },
  overtimeAgreement: {
    overtimeAgreementTerm: {
      "ui:md": 12,
      "ui:field": "AgreementCheckboxField",
    },
  },
  cancellationFees: {
    cancellationFeesTerm: { "ui:md": 12, "ui:field": "AgreementCheckboxField" },
  },
  hospitalization: {
    hospitalizationTerm: {
      "ui:md": 12,
      "ui:field": "AgreementCheckboxField",
      "ui:description": (
        <>
          <i>
            This policy is designed to balance the needs of Clients during
            unplanned medical events with the Cambridge Caregiver's obligation
            to maintain predictable scheduling and income stability for its
            Caregivers.
          </i>
          <br />
          <br />
          If the Client or the Client's Authorized Representative requests
          continued caregiving services during a hospitalization, the assigned
          Caregiver may be redirected to the hospital to provide services for
          the duration of the scheduled shift.
        </>
      ),
    },
  },
  cancellationWithAtLeastFourHours: {
    cancellationWithAtLeastFourHoursTerm: {
      "ui:md": 12,
      "ui:field": "AgreementCheckboxField",
    },
  },
  cancellationWithLessThanFourHours: {
    cancellationWithLessThanFourHoursTerm: {
      "ui:md": 12,
      "ui:field": "AgreementCheckboxField",
    },
  },
  holidaysAndOvertime: {
    holidaysAndOvertimeTerm: {
      "ui:md": 12,
      "ui:field": "AgreementCheckboxField",
    },
  },
  mileageReimbursement: {
    mileageReimbursementTerm: {
      "ui:md": 12,
      "ui:field": "AgreementCheckboxField",
    },
  },
  lateCharges: {
    lateChargesTerm: { "ui:md": 12, "ui:field": "AgreementCheckboxField" },
  },
  insurance: {
    insuranceTerm: { "ui:md": 12, "ui:field": "AgreementCheckboxField" },
  },
  privacyConsent: {
    privacyConsentTerm: {
      "ui:md": 12,
      "ui:field": "AgreementCheckboxField",
      "ui:description": (
        <>
          I agree with the storage and handling of my data by this website found
          at{" "}
          <a
            href="https://cambridgecaregivers.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://cambridgecaregivers.com/privacy-policy/
          </a>
          .
        </>
      ),
    },
  },
  obligationOfResponsibleParty: {
    obligationOfResponsiblePartyTerm: {
      "ui:md": 12,
      "ui:field": "AgreementCheckboxField",
    },
  },
  clientServicePlanAcknowledgement: {
    clientServicePlanAcknowledgementFields: {
      "ui:order": [
        "description",
        "clientSignatureAndContactInfo",
        "date",
        "printedClientName",
        "agencyRepresentativeSign",
      ],
      description: {
        "ui:md": 12,
        "ui:field": "DescriptionField",
      },
      clientSignatureAndContactInfo: {
        "ui:md": 6,
        signatureOfClient: {
          "ui:widget": "SignatureWidget",
          "ui:options": {
            label: false,
          },
          "ui:md": 12,
        },
      },
      date: {
        "ui:md": 6,
        "ui:widget": "DateWidget",
        "ui:options": {
          style: { marginTop: "16px" },
        },
      },
      printedClientName: {
        "ui:md": 12,
        "ui:options": {
          style: { width: "440px" },
        },
      },
      agencyRepresentativeSign: {
        "ui:widget": "ImageWidget",
        "ui:options": {
          labelText:
            "Ernie Cote\nChief Operating Officer\nAgency Representative",
        },
        "ui:md": 6,
      },
    },
  },
};
